import { render, staticRenderFns } from "./DocumentApercu.vue?vue&type=template&id=61fc2bd0&scoped=true&"
import script from "./DocumentApercu.vue?vue&type=script&lang=js&"
export * from "./DocumentApercu.vue?vue&type=script&lang=js&"
import style0 from "./DocumentApercu.vue?vue&type=style&index=0&id=61fc2bd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61fc2bd0",
  null
  
)

export default component.exports